const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

const depositRouter = {
  path: '/property/deposit',
  component: index,
  children: [
    {
      path: 'depositOverview',
      name: 'propertyDepositOverview',
      component: () => import('@/pages/property/deposit/mgt/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '押金管理',
      },
    },
    {
      path: 'depositDetail',
      name: 'propertyDepositDetail',
      component: () => import('@/pages/property/deposit/mgt/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '押金详情',
      },
    },
    {
      path: 'depositAudit',
      name: 'propertyDepositAudit',
      component: () => import('@/pages/property/deposit/audit/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '押金审核',
      },
    },
    {
      path: 'depositAuditDetail',
      name: 'propertyDepositAuditDetail',
      component: () => import('@/pages/property/deposit/audit/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '押金审核',
      },
    },
  ],
};

export default depositRouter;
